// extracted by mini-css-extract-plugin
module.exports = {"footerBottom":"footer_footerBottom__t0K9T","footerList":"footer_footerList__zel6G","footerLink":"footer_footerLink__fLfjq","footerSocialIcon":"footer_footerSocialIcon__NyD1Q"};